// test2786
(2786 && 0);
